/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { useEffect } from 'react'
import ApexCharts from 'apexcharts'
import { Flex } from '@chakra-ui/react'
import { GraficoPEC, ItemGrafico } from '../../../../interfaces'
import { processString } from '../../../../../../../../Utils/Helper'

interface iChartProps {
  id: string
  dados: GraficoPEC
  setGrafico: (blob: string) => void
}

export const BarChartBordaPDF: React.FC<iChartProps> = ({ id, dados, setGrafico }) => {
  function GetSeries(): any {
    const resp: any[] = []
    dados.serie?.forEach(e => {
      resp.push(e)
    })

    return [{
      name: 'Média do engajamento',
      data: resp.map((e, i) => {
        return {
          strokeColor: (dados.afetaEngajamento[i]) ? 'rgb(3, 112, 21)' : undefined,
          y: e,
          x: dados.labels?.[i]
        }
      })
    }]
  }
  async function GerarGrafico(): Promise<void> {
    const options = {
      colors: ['rgb(3, 112, 21)', 'rgb(56, 99, 176)', 'rgba(55, 159, 232, 0.5)'],
      series: GetSeries(),
      chart: {
        type: 'bar',
        height: 450,
        width: 750,
        animations: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#000']
        },
        formatter: function(val: number) {
          if (val === -1) {
            return '#'
          } else {
            return val.toFixed(2)
          }
        }
      },
      plotOptions: {
        bar: {
          distributed: true,
          dataLabels: {
            position: 'top'
          }
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        customLegendItems: ['Atributos que afetaram o engajamento', 'Média do engajamento', 'Média dos demais atributos'],
        position: 'top',
        fontSize: '16px',
        itemMargin: {
          horizontal: 10
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      grid: {
        xaxis: {
          lines: {
            show: true
          }
        },
        yaxis: {
          lines: {
            show: false
          }
        }
      },
      yaxis: {
        min: 0,
        max: 10,
        tickAmount: 10,
        show: true,
        labels: {
          formatter: function(val: string) {
            return parseFloat(val).toFixed(1)
          }
        }
      },
      xaxis: {
        categories: dados.labels?.map(e => processString(e)),
        labels: {
          rotate: -45,
          rotateAlways: true,
          style: {
            fontSize: '10px'
          }
        }
      },
      fill: {
        opacity: 1,
        colors: dados.serie?.map((e, i) => {
          if (i === 0) {
            return 'rgb(56, 99, 176)'
          } else {
            return 'rgba(55, 159, 232, 0.5)'
          }
        })
      },
      tooltip: {
        y: {
          formatter: function (val: number) {
            return val.toFixed(2)
          }
        }
      }
    }

    const chart = new ApexCharts(document.querySelector(`#${id}`), options)
    chart.render()

    const dataURL = await chart.dataURI().then((value: any) => {
      return value
    })

    setGrafico(dataURL.imgURI)
  }

  useEffect(() => {
    GerarGrafico()
  }, [dados])

  return (
    <Flex w={'100%'} justifyContent={'center'} position={'relative'}>
      <div id={id}></div>
    </Flex>
  )
}
